import React from "react";
import styled, { css } from "react-emotion";
import * as styles from "../newStyles.styles";
import { ContactForm } from "components";
import Footer from "../Footer";
import Header from "../Header";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const offwhite = css`
  background-color: #f6fbfb;
`;

const col1 = css`
  text-align: center;
`;

const contactImage = css`
  width: 375px;
  @media only screen and (min-width: 768px) {
    width: 400px;
  }
  @media only screen and (min-width: 900px) {
    width: 480px;
  }
  @media only screen and (min-width: 1200px) {
    width: 510px;
  }
`;
const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

const H5 = styled("h5")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #89d2d3;
  margin: 10px 0px;
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

function Contact({ history }) {
  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <main
          style={{
            width: "100%",
            minHeight: "100vh",
            backgroundColor: "rgb(255, 255, 255)",
            flex: "1 0 auto",
            textAlign: "center",
          }}
        >
          <div className={styles.row}>
            <div className={styles.maxWidthWrapper}>
              <styles.H2
                style={{
                  textAlign: "center",
                  width: "100%",
                  margin: "30px 0px",
                }}
              >
                We're here for{" "}
                <span className={styles.styledUnderline}>you.</span>
              </styles.H2>
            </div>
          </div>

          <div
            className={styles.row}
            style={{
              padding: "0px",
            }}
          >
            <div className={styles.maxWidthWrapper}>
              <div className={styles.col + " " + styles.col3}>
                <img
                  className={contactImage}
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/contact+us+image%402x.png"
                  alt="contact-img"
                ></img>
              </div>
              <div
                className={styles.col + " " + styles.col1_4_pic}
                style={{ padding: "0px" }}
              >
                <H5
                  style={{
                    color: "#aed9da",
                    textAlign: "left",
                  }}
                >
                  Leave us a note
                </H5>
                <ContactForm></ContactForm>
                <H5
                  style={{
                    color: "#aed9da",
                    textAlign: "left",
                  }}
                >
                  Give us a call
                </H5>
                <P
                  style={{
                    color: "#89d2d3",
                    textAlign: "left",
                  }}
                >
                  (510) 456-0601
                </P>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default Contact;
